import React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import Button from "@mui/material/Button"
import CloseIcon from "@mui/icons-material/Close"

import SignIn from "./SignIn"

interface Props {
  open: boolean
  message: string
  closeCallback: () => void
  signInCallback?: () => void
  providers?: string[] | null
  showEmailChangeAction?: boolean
  displaySignUpBtn?: boolean
  emailFromForm?: string | null
}

function SignInModal({
  open,
  closeCallback,
  signInCallback,
  message,
  emailFromForm,
  providers = ["email", "facebook", "google"],
  showEmailChangeAction = true,
  displaySignUpBtn = false,
}: Props) {
  return (
    <Dialog open={open} data-cy="signin-modal">
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
        <div style={{ marginTop: 20 }}>
          <SignIn
            emailFromForm={emailFromForm ?? undefined}
            providers={providers ?? undefined}
            signInCallback={signInCallback}
            displaySignUpBtn={displaySignUpBtn}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => closeCallback()}
          data-cy="close-btn"
        >
          {showEmailChangeAction ? <>Use a Different Email</> : <CloseIcon />}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SignInModal
